const{REACT_APP_API_URL,REACT_APP_CLIENT_IDS,REACT_APP_REDIRECT_URL}=process.env;
export const API_PATH = `${REACT_APP_API_URL}/api`
export const CLIENT_ID = REACT_APP_CLIENT_IDS
export const REDIRECT_URL = REACT_APP_REDIRECT_URL
